import { isNil } from 'lodash';
import { UAParser } from 'ua-parser-js';

/**
 * Try to get the browser name from the user agent using UIParser
 * If anything is found, the output will be lowercased
 * See: https://github.com/faisalman/ua-parser-js
 */
function getBrowserName(): string | undefined {
  const parser = new UAParser();
  const parsedUA = parser.getResult();
  if (parsedUA?.browser?.name) {
    return (parsedUA?.browser?.name as string)?.toLowerCase?.();
  }
}

function isBrowser(browserNames: string[]): boolean {
  const browserName = getBrowserName();
  return !isNil(browserName) && browserNames.includes(browserName);
}

// Validate if browser is supported - we currently do not support internet explorer
export function isBrowserSupported() {
  return !isBrowser(['iemobile', 'ie']);
}

export function isBrowserFirefox() {
  return isBrowser(['firefox']);
}

export function isBrowserSafari() {
  return isBrowser(['safari']);
}

export function isBrowserEdge() {
  return isBrowser(['edge']);
}

export function isBrowserChrome() {
  return isBrowser(['chrome', 'chromium']);
}

export function isBrowserOpera() {
  return isBrowser(['opera', 'opera mini', 'opera mobi', 'opera tablet']);
}

// Check if browser can access session storage
export function isIncognito() {
  try {
    window.sessionStorage.setItem('test', 'test');
    window.sessionStorage.removeItem('test');
  } catch (e) {
    return true;
  }

  return false;
}
